'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requestStack;

var _requests = require('../actions/requests');

var initialState = {};

function requestStack() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type == _requests.ADD_TO_REQUEST_STACK) {
        return Object.assign(state, action.payload);
    }
    return state;
}
//# sourceMappingURL=requests.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/reducers/requests.js
// module id = 1285
// module chunks = 5